exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LabelBlock_label_EuXa {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 4px 20px;\n\n  border-radius: 16px 0;\n  background: #ffe02c;\n}\n", ""]);

// exports
exports.locals = {
	"label": "LabelBlock_label_EuXa"
};